import { useCallback } from "react";

export const useReplaceMessage = (fieldsInfo = []) => {
  const replaceMessage = useCallback(
    (text) => {
      if (!text) return "";

      const text_replace = text.replace(/{(.*?)}/g, (item, key) => {
        const field = fieldsInfo.find((item) => item.vc_keycolumn === key);
        return field ? field.vc_value : item;
      });

      return text_replace;
    },
    [fieldsInfo]
  );

  return replaceMessage;
};
